import api from '../api/axios';

// «Ödəniş və abunə» məlumatı üçün yaddaş keşi (5 dəq.): panel açılanda bir dəfə alınır,
// bölməyə girəndə iframe dərhal yüklənməyə başlayır. Link GİZLİDİR: localStorage-a yazılmır.
const TTL = 5 * 60 * 1000;
let meCache = null;      // { at, data }
let mePending = null;
let statusCache = null;  // { at, license }
let statusPending = null;

export const isPayAdmin = (user) => user?.role === 'admin' && !user?.is_manager;

export const getPaymentMe = async ({ fresh = false } = {}) => {
    if (!fresh && meCache && Date.now() - meCache.at < TTL) return meCache.data;
    if (mePending) return mePending;
    mePending = api.get('/payment/me', { timeout: 20000 })
        .then((r) => {
            meCache = { at: Date.now(), data: r.data };
            if (r.data?.license) statusCache = { at: Date.now(), license: r.data.license };
            return r.data;
        })
        .finally(() => { mePending = null; });
    return mePending;
};

export const getLicenseStatus = async () => {
    if (statusCache && Date.now() - statusCache.at < TTL) return statusCache.license;
    if (statusPending) return statusPending;
    statusPending = api.get('/payment/status')
        .then((r) => {
            statusCache = { at: Date.now(), license: r.data?.license || null };
            return statusCache.license;
        })
        .finally(() => { statusPending = null; });
    return statusPending;
};

export const clearPaymentCache = () => { meCache = null; statusCache = null; };

export const formatYmd = (ymd) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(ymd || ''));
    return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
};

export const licenseLine = (license) => {
    if (!license) return '';
    const date = formatYmd(license.expiry);
    if (license.state === 'expired') return `Lisenziyanın vaxtı bitib${date ? ` (${date})` : ''}`;
    if (license.state === 'disabled') return 'Lisenziya icazəsi deaktivdir';
    if (license.state !== 'active') return '';
    const d = Number(license.daysLeft);
    const left = Number.isFinite(d) ? (d === 0 ? 'bu gün bitir' : `${d} gün qalıb`) : '';
    return [date ? `Lisenziya ${date} tarixinədək aktivdir` : 'Lisenziya aktivdir', left].filter(Boolean).join(' · ');
};
